import { mockApi, mockApiPrices, urlApiPrices, } from "../api.js";
import { dateFormatter, getJson } from "../util.js";
const T = "#C0BAA8";
const TD = "#7a7468";
const integerFormatter = new Intl.NumberFormat("ru-RU");
const fractionFormatter = new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
const isMobile = () => window.innerWidth < 640;
const ALL_PRICING_COLUMNS = [
    { key: "input_tokens", label: "Вход" },
    { key: "output_tokens", label: "Выход" },
    { key: "cache_read_tokens", label: "Кэш чтение" },
    { key: "cache_5m_write_tokens", label: "Кэш запись" },
];
const MOBILE_PRICING_COLUMNS = [
    { key: "input_tokens", label: "Вход" },
    { key: "output_tokens", label: "Выход" },
];
const getPricingColumns = () => isMobile() ? MOBILE_PRICING_COLUMNS : ALL_PRICING_COLUMNS;
export function addPricingTable() {
    const rowsRoot = document.getElementById("pricing-table-body");
    const dateEl = document.getElementById("pricing-updated-at");
    if (!rowsRoot || !dateEl) {
        return;
    }
    void loadPricing(rowsRoot, dateEl);
}
async function loadPricing(rowsRoot, dateEl) {
    patchMobileHeader();
    try {
        const data = mockApi
            ? mockApiPrices
            : await getJson(`${urlApiPrices}?short-list`);
        dateEl.textContent = formatPricingDate(data);
        renderRows(rowsRoot, data);
    }
    catch {
        dateEl.textContent = formatPricingDate();
        renderMessage(rowsRoot, "тарифы временно недоступны");
    }
}
function patchMobileHeader() {
    const head = document.getElementById("pricing-head");
    if (!head || !isMobile())
        return;
    head.style.gridTemplateColumns = "minmax(0,1fr) 7ch 7ch";
    const spans = head.querySelectorAll("span");
    spans[3]?.style.setProperty("display", "none");
    spans[4]?.style.setProperty("display", "none");
}
function renderRows(rowsRoot, data) {
    const rows = buildRows(data);
    rowsRoot.replaceChildren();
    if (rows.length === 0) {
        renderMessage(rowsRoot, "тарифы не найдены");
        return;
    }
    const columns = getPricingColumns();
    for (const row of rows) {
        const cells = [
            row.modelLabel,
            ...columns.map((column) => formatPriceValue(column.key, row.prices[column.key]) || "—"),
        ];
        rowsRoot.appendChild(createRow(cells));
    }
}
function renderMessage(rowsRoot, message) {
    const columns = getPricingColumns();
    rowsRoot.replaceChildren(createRow([message, ...Array(columns.length).fill("")], true));
}
function createRow(cells, muted = false) {
    const mobile = isMobile();
    const colCount = getPricingColumns().length;
    const gridCols = mobile
        ? `minmax(0,1fr) ${Array(colCount).fill("7ch").join(" ")}`
        : `28ch ${Array(colCount).fill("11ch").join(" ")}`;
    const padding = mobile ? "5px 0" : "7px 0";
    const row = document.createElement("div");
    row.style.cssText = [
        "display:grid",
        `grid-template-columns:${gridCols}`,
        "gap:0 2ch",
        `padding:${padding}`,
        `color:${T}`,
        mobile ? "font-size:11px" : "font-size:12px",
        "line-height:1.5",
    ].join(";");
    cells.forEach((cell, index) => {
        const span = document.createElement("span");
        span.textContent = cell;
        span.style.textAlign = index === 0 ? "left" : "right";
        if (index === 0) {
            span.style.overflow = "hidden";
            span.style.textOverflow = "ellipsis";
            span.style.whiteSpace = "nowrap";
        }
        if (muted && index === 0) {
            span.style.color = TD;
        }
        row.appendChild(span);
    });
    return row;
}
function buildRows(data) {
    const providers = Object.entries(data.providers).sort(([a], [b]) => a.localeCompare(b));
    return providers.flatMap(([providerId, provider]) => {
        const rows = [];
        const modelEntries = Object.entries(provider.models).sort(([a], [b]) => a.localeCompare(b));
        for (const [modelId, model] of modelEntries) {
            rows.push({
                providerId,
                modelId,
                modelLabel: model.display_name ?? modelId,
                prices: model.prices,
            });
        }
        return rows;
    });
}
function formatPriceValue(key, value) {
    if (value === undefined) {
        return "";
    }
    const normalized = key === "web_search_requests" ? value / 1000 : value;
    return Number.isInteger(normalized)
        ? integerFormatter.format(normalized)
        : fractionFormatter.format(normalized);
}
function formatPricingDate(data) {
    const updatedAt = data
        ?.updated_at_unix_s;
    if (typeof updatedAt === "number" && Number.isFinite(updatedAt)) {
        return dateFormatter.format(new Date(updatedAt * 1000));
    }
    return dateFormatter.format(new Date());
}
